import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import alert from './modules/alert'
import cutting from './modules/cutting'
import * as types from '@/store/types'

Vue.use(Vuex)

const state = {
  isExpandLeftMenu: false,
}

const getters = {
  isExpandLeftMenu: state => state.isExpandLeftMenu,
}

const actions = {
  [types.EXPAND_LEFT_NAVIGATION]: (context) => {
    context.commit(types.EXPAND_LEFT_NAVIGATION)
  }
}

const mutations = {
  [types.EXPAND_LEFT_NAVIGATION]: (state, value) => {
    state.isExpandLeftMenu = value
  }
}

export default new Vuex.Store({
  modules: {
    auth,
    cutting,
    alert
  },
  state,
  getters,
  actions,
  mutations
})
